/**
 * Builds the public URL for a project tenant site from the current browser
 * location (protocol, port, which tenant host we’re on). Works on apex or any
 * project subdomain — strips the current tenant label so preview targets the
 * same registration domain (e.g. cburt.gearrecoverynetwork.org).
 *
 * @param {Location | { protocol?: string, hostname?: string, port?: string }} [loc]
 */
export function getProjectHostingBase(loc) {
  const location =
    loc ||
    (typeof window !== "undefined" ? window.location : { hostname: "" });
  const protocol = location.protocol || "https:";
  const hostname = String(location.hostname || "").toLowerCase();
  const port = location.port || "";
  const labels = hostname.split(".").filter(Boolean);
  const last = labels[labels.length - 1];

  let baseLabels;
  if (last === "localhost") {
    if (labels.length >= 2) {
      baseLabels = labels.slice(1);
    } else {
      baseLabels = ["localhost"];
    }
  } else if (labels.length >= 3) {
    baseLabels = labels.slice(1);
  } else {
    baseLabels = labels;
  }

  const hostOnly = baseLabels.join(".");
  const omitPort =
    !port ||
    (protocol === "https:" && port === "443") ||
    (protocol === "http:" && port === "80");
  const portSuffix = omitPort ? "" : `:${port}`;

  return { hostOnly, portSuffix, protocol };
}

/**
 * Full URL for a new project’s subdomain on this deployment.
 * @param {string} subdomainSlug — raw tenant slug (trimmed / normalized by caller)
 */
export function previewProjectSiteUrl(subdomainSlug, loc) {
  const slug = String(subdomainSlug || "").trim().toLowerCase();
  const { hostOnly, portSuffix, protocol } = getProjectHostingBase(loc);
  if (!slug) {
    return `${protocol}//${hostOnly}${portSuffix}`;
  }
  return `${protocol}//${slug}.${hostOnly}${portSuffix}`;
}
